export const MIDDLEWARE = {
  CONTRIBUTOR_WITHOUT_DETAILS: 'contributor-without-details',
  PAGE_SEO: 'page-seo',
  PATH_REPLACE: 'path-replace',
  PREVENT_ROUTING: 'prevent-routing',
  ROUTER_NAVIGATION_DETAILS: 'router-navigation-details',
  SEO_REDIRECT: 'seo-redirect',
  REDIRECT_410: '410-redirect',
  CONTENT_REFRESH_IN_BACKGROUND: 'content-refresh-in-background',
  REMOVE_LOCAL_CMP_HANDLERS: 'remove-local-cmp-handlers'
}
